import store from '../store';

export default class Settings {
  constructor(api) {
    this.api = api
  }

  load() {
    return this.api.call_busy({
      '_class': 'Settings',
      '_method': 'load',
      'xml': `<request>
  <setting name="user"/>
  <setting name="rights"/>
  <setting name="widgets"/>
  <setting name="reports"/>
</request>`
    }).then(res => {
      // TODO: validation
      // let settings = res
      // TODO: transform settings
      let settings = {}
      settings.account = res.account._attributes
      res.account.setting.forEach(a => {
        let name = a._attributes.name
        delete(a._attributes)
// console.log(a)
        Object.keys(a).map(k => { a[k] = a[k]._text || a[k] });
        settings[name] = a
      })

      if (settings.user.visible_columns) {
        settings.user.visible_columns.column = settings.user.visible_columns.column ? (settings.user.visible_columns.column.length ? settings.user.visible_columns.column : [settings.user.visible_columns.column]) : []
        settings.user.visible_columns.column = settings.user.visible_columns.column.map(a => a._text)
      } else {
        settings.user.visible_columns = {
          column: ['lastname', 'firstname', 'company', 'email', 'newsletter', 'bounced', 'phone', 'zipStreet', 'city']
        }
      }
      if (!settings.user.results_per_page) {
        settings.user.results_per_page = 20
      }
      if (!settings.user.auto_refresh_results) {
        settings.user.auto_refresh_results = 1
      }

      store.commit('setSettings', settings)
    },
    err => {
      // store.commit('decInit')
      store.dispatch('clearIsBusy')
      store.dispatch('resetIsInit')
      throw err
    })
  }

  save(xml) {
    return this.api.call_busy({
      '_class': 'Settings',
      '_method': 'save',
      'xml': xml
    })
  }

  // eslint-disable-next-line no-unused-vars
  change_lang(lang) {
    // return this.api.call_busy({
    //   '_class': 'Settings',
    //   '_method': 'change_lang',
    //   'lang': lang
    // }).then(res => {
    //   // store.commit('setLang', res._attributes.lang)
    //   store.commit('setLang', lang)
    // })
  }

}
